import { createSettingsListApi } from './settings-list-api.factory';

export const recordIndexersApi = createSettingsListApi('/record-indexers');
